import { createFileRoute } from "@tanstack/react-router";
import { FornecedoresCadastroPage } from "@/paginas/pg_empresa/empresa-fornecedores-cadastro";

export const Route = createFileRoute("/_authenticated/empresa-fornecedores-cadastro")({
  head: () => ({
    meta: [
      { title: "Cadastro de fornecedores — Milky Moo Palmares" },
      {
        name: "description",
        content: "Cadastro e manutenção dos fornecedores da sorveteria, com impressão e PDF.",
      },
      { property: "og:title", content: "Cadastro de fornecedores — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Cadastro e manutenção dos fornecedores da sorveteria, com impressão e PDF.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: FornecedoresCadastroPage,
});
